import "jquery-ui/ui/widgets/sortable";
import "3pp/pivot";
import "3pp/plotly_renderers";
import "flow/configuration/pivotTableInitializer-sv.js";

window.define('3pp/plotly-bundle', [], function() { return __webpack_module__.exports; });